<template>
  <v-card :color="color">
    <v-card-title primary-title
                  class="pb-0 pt-3">
      <h2 class="title mb-0">
        Wheel No.{{wheel.id}}, WheelAccount No.{{wheel.wheelAccountId}} {{wheelAccounts}}
      </h2>
    </v-card-title>
    <v-card-text>
      <v-data-table hide-actions
                    :loading="loading"
                    :headers="headers"
                    :items="items"
                    class="elevation-1">
        <template v-slot:items="props">
          <td class="text-xs-center">{{ props.item.id }}</td>
          <td class="text-xs-center">{{ props.item.displayId }}</td>
          <td class="text-xs-center">{{ props.item.result }}</td>
          <td class="text-xs-center">{{ formatRoundDate(props.item.createdAt) }}</td>
          <td class="text-xs-center">{{ formatRoundDate(props.item.resolvedAt) }}</td>
        </template>
      </v-data-table>
    </v-card-text>
    <v-alert :value="loadingError"
             type="error">
      Error getting rounds.
    </v-alert>
  </v-card>
</template>

<script>
import { take, uniqBy } from 'lodash';
import { DateTime } from 'luxon';
import { rounds } from '@/api';

export default {
  name: 'MonitoringRoundsTable',
  props: {
    wheel: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      loadingError: false,
      loadingInterval: null,
      headers: [
        {
          text: 'ID',
          value: 'id',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Display ID',
          value: 'displayId',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Result',
          value: 'result',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Created At',
          value: 'createdAt',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Resolved At',
          value: 'resolvedAt',
          align: 'center',
          sortable: false,
        },
      ],
      items: [],
    };
  },
  computed: {
    color() {
      const colors = {
        1: 'orange',
        2: 'red',
      };

      return this.errorLevel > 0 ? colors[this.errorLevel] : 'white';
    },
    errorLevel() {
      if (this.items.length <= 0) {
        return 0;
      }

      const sample = take(this.items, 3);
      const uniqueDisplayIds = uniqBy(sample, 'displayId').length;
      const uniqueResults = uniqBy(sample, 'result').length;
      const isWarning = uniqueResults < sample.length && sample[0].result === sample[1].result;
      const isError = uniqueDisplayIds < sample.length || uniqueResults <= 1;

      let level = 0;
      if (isError) {
        level = 2;
      } else if (isWarning) {
        level = 1;
      }

      return level;
    },
    wheelAccounts() {
      const { accounts } = this.wheel;
      return accounts ? `(${accounts.join(', ').trim()})` : null;
    },
  },
  methods: {
    formatRoundDate(value) {
      return DateTime.fromISO(value, {
        zone: 'local',
      }).toFormat('dd.MM.yyyy HH:mm');
    },
    loadRounds() {
      this.loading = true;
      this.loadingError = false;
      rounds.getRounds(this.wheel, {
        locale: 'en',
        pageSize: 10,
      }).then((result) => {
        this.loading = false;
        this.items = result.rounds;
        this.setLoadRoundsInterval();
      }).catch(() => {
        this.loadingError = true;
        this.loading = false;
        this.items = [];
        this.setLoadRoundsInterval();
      });
    },
    setLoadRoundsInterval() {
      clearTimeout(this.loadingInterval);
      this.loadingInterval = setTimeout(() => {
        this.loadRounds();
      }, 120000);
    },
  },
  mounted() {
    this.loadRounds();
    this.setLoadRoundsInterval();
  },
};
</script>
